
import formAPIOrdersConsultation from "./consultation";


var formattedOutput = null;

const formAPIModelOrdersConsultations = (data) => {
  // Apply formAPIModel to each item in the data array
  formattedOutput = data?.map(item => formAPIOrdersConsultation(item));


  return formattedOutput
};

export default formAPIModelOrdersConsultations